import React from "react";
import { Typography, Box, useTheme } from "@mui/material";

interface SectionMainTitleProps {
  title: string;
  highlight?: string;
  align?: "left" | "center" | "right";
  mt?: number;
  mb?: number;
}

const SectionMainTitle: React.FC<SectionMainTitleProps> = ({
  title,
  highlight,
  align = "left",
  mt = 0,
  mb,
}) => {
  const theme = useTheme();
  const words = title.split(" ");

  return (
    <Typography
      variant="h4"
      component="h2"
      sx={{
        fontWeight: { xs: 700, sm: 900 },
        fontSize: { xs: "2rem", md: "2.5rem" },
        mt: { mt },
        mb: mb,
        textAlign: {
          xs: "left",
          sm: align,
          md: align,
        },
        color: theme.palette.common.white,
        scrollMarginTop: "100px",
      }}
    >
      {words.map((word, index) =>
        highlight && word.toLowerCase() === highlight.toLowerCase() ? (
          <Box
            key={index}
            component="span"
            sx={{ color: theme.palette.primary.main }}
          >
            {" "}
            {word}
          </Box>
        ) : (
          ` ${word}`
        )
      )}
    </Typography>
  );
};

export default SectionMainTitle;
